<template>
  <div>
    <!-- Standard-Jumbotron -->
    <b-jumbotron
      v-if="schema === 'default'"
      :style="{ 'background-image': (homeData.headerbild ? `url(${homeData.headerbild})` : 'none') }"
      id="dhn-jumbo-header"
    >
      <b-container>
        <h1 class="#">{{ pageTitle }}</h1>
      </b-container>
    </b-jumbotron>
    <!-- Jumbotron für KSS-Seite -->
    <b-jumbotron
      v-if="schema === 'kss'"
      style="{ 'background-color: #5f713f;') }"
      id="dhn-jumbo-header"
      class="kss-jumbotron"
    >
      <b-container>
        <b-img
          src="/img/kss-logo.jpg"
          class="d-block w-15 my-4"
        />
        <h1 class="kss-headline">{{ staticData.kssTitel }}</h1>
      </b-container>
    </b-jumbotron>
    <!-- Jumbotron für Partner-Seite -->
    <b-jumbotron
      v-if="schema === 'partner'"
      :style="{ 'background-image': (homeData.headerbild ? `url(${homeData.headerbild})` : 'none') }"
      id="dhn-jumbo-header"
    >
      <b-container>
        <h1 class="">{{ staticData.partnerTitel }}</h1>
      </b-container>
    </b-jumbotron>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'navbar',
  props: {
    pageTitle: String,
    schema: String
  },
  methods: {
    ...mapActions([
      'switchLanguage'
    ])
  },
  computed: {
    ...mapGetters({
      homeData: 'getHomeData',
      staticData: 'getStaticData'
    })
  }
}
</script>

<style scoped lang="scss">
</style>
